export default {
    groupName: 'comcast-smb',
    appName: 'Comcast Business',
    baseRoute: '/dashboard/comcast-smb',
    label: 'AdPi Dashboard',
    home: '/slicer',
    image: 'dummy-2.png',
    description: 'Comcast Business AdPi Dashboard'
}